import APIClient from '@/shared/http/clients/api'

const resourceName = 'permissao'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}`, data, config)

const PermissionRepository = {
  GetAll,
  Create
}

export default PermissionRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/permission.js